// client/src/recruitingRoutes.js — agent recruiting routes, in one file (App.js spreads
// these, the same way as wave2Routes.js and ownerListingRoutes.js).
import React from 'react';
import { Route } from 'react-router-dom';
import WorkWithUsPage from './pages/WorkWithUsPage';
import RecruitingPage from './pages/secure/RecruitingPage';

/** Inside the public layout. */
export const recruitingPublicRoutes = () => [
    <Route key="rc-public" path="work-with-us" element={<WorkWithUsPage />} />,
];

/** Under /dashboard (staff login). */
export const recruitingDashboardRoutes = () => [
    <Route key="rc-admin" path="recruiting" element={<RecruitingPage />} />,
];
